/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "//h.cdn.pengpengla.com/up/h5redirect/1.1.0/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

(function (global) {

    function createInput(name, value) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = value;
        return input;
    }

    global.h5redirect = function (options) {
        var doc = global.document,
            protocol = global.location.protocol;
        // 授权后跳转的URL
        var url = options.url || 'http://h5.upliveapp.com/uppro/index.html';
        // 存储信息的,key,value的形式
        var storeData = options.data || {};
        // 中转页的地址，域名和授权后的url一致就可以了
        var origin = url.match(/https?:\/\/(.*?)\//)[1] || 'h5.upliveapp.com';
        var redirectAction = protocol + '//' + origin + '/h5redirect/redirect.php';

        if (origin.indexOf('aws') > -1) {
            redirectAction = protocol + '//' + origin + '/up/h5redirect/redirect.php';
        }

        var form = doc.createElement('form');
        form.action = redirectAction;
        form.method = 'post';
        form.target = '_blank';
        form.style.display = 'none';
        form.appendChild(createInput('url', url));
        form.appendChild(createInput('data', JSON.stringify(storeData)));

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };
})(window);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// redirect.js